import { useEffect, useState, Fragment } from "react";
import { api, errDetail, fmtEur } from "../lib/api";
import { toast } from "sonner";
import { Badge } from "../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Scale, ChevronDown, ChevronRight } from "lucide-react";

export default function PriceVariance() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState({});
  useEffect(() => { api.get("/srm/spend/price-variance").then((r) => setData(r.data)).catch((e) => toast.error(errDetail(e))); }, []);
  if (!data) return <div className="p-6 text-gray-400">Lädt…</div>;
  return (
    <div className="p-6 max-w-[1300px] mx-auto" data-testid="price-variance-page">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-[#1B2A4A] flex items-center justify-center"><Scale className="h-5 w-5 text-[#F5A623]" /></div>
          <div><h1 className="text-2xl font-bold text-[#1B2A4A]">Cross-Plant Preisvarianz</h1><p className="text-sm text-gray-500">Gleicher Artikel, mehrere Werke — annualisiertes Einsparpotenzial</p></div>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 px-4 py-2 text-right" data-testid="total-opportunity">
          <div className="text-xs text-gray-500">Gesamtpotenzial</div><div className="text-xl font-bold text-green-600">{fmtEur(data.total_opportunity)}</div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead></TableHead><TableHead>Artikel</TableHead><TableHead>Günstigstes Werk</TableHead><TableHead>Teuerstes Werk</TableHead><TableHead className="text-right">Δ pro {`Einheit`}</TableHead><TableHead className="text-right">Δ %</TableHead><TableHead className="text-right">Potenzial p.a.</TableHead></TableRow></TableHeader>
          <TableBody>
            {data.articles.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-gray-400 py-8">Keine Artikel mit Mehrwerk-Beschaffung</TableCell></TableRow>}
            {data.articles.map((a) => (
              <Fragment key={a.article_id}>
                <TableRow className="cursor-pointer hover:bg-gray-50" data-testid={`pv-row-${a.article_id}`} onClick={() => setOpen((o) => ({ ...o, [a.article_id]: !o[a.article_id] }))}>
                  <TableCell>{open[a.article_id] ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}</TableCell>
                  <TableCell className="font-medium text-[#1B2A4A]">{a.article_name || a.article_id}</TableCell>
                  <TableCell className="text-green-700">{a.cheapest_plant} · {fmtEur(a.min_price)}</TableCell>
                  <TableCell className="text-red-700">{a.dearest_plant} · {fmtEur(a.max_price)}</TableCell>
                  <TableCell className="text-right">{fmtEur(a.gap_abs)}/{a.base_uom}</TableCell>
                  <TableCell className="text-right"><Badge className={a.gap_pct > 15 ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-800"}>{a.gap_pct}%</Badge></TableCell>
                  <TableCell className="text-right font-semibold text-green-600">{fmtEur(a.annualized_gap)}</TableCell>
                </TableRow>
                {open[a.article_id] && (
                  <TableRow key={`${a.article_id}-d`}><TableCell colSpan={7} className="bg-gray-50 p-0">
                    <div className="px-8 py-3">
                      <div className="text-xs font-semibold text-gray-500 mb-2">Preis je Werk (normalisiert auf {a.base_uom})</div>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                        {a.plants.map((p) => <div key={p.plant_id} className="bg-white rounded-lg border border-gray-200 px-3 py-2" data-testid={`pv-plant-${a.article_id}-${p.plant_id}`}><div className="text-sm font-medium">{p.plant_name}</div><div className="text-lg font-bold text-[#1B2A4A]">{fmtEur(p.price_base)}</div><div className="text-xs text-gray-400">{p.qty_base} {p.base_uom}</div></div>)}
                      </div>
                    </div>
                  </TableCell></TableRow>
                )}
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
